import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chapterContent", "chapterChevron", "profileContent", "profileChevron"]

  connect() {
    // Set initial max-height and chevron rotation for expanded/collapsed chapters
    this.chapterContentTargets.forEach(content => {
      const chapterId = content.dataset.chapterId
      const chevron = this.chapterChevronTargets.find(el => el.dataset.chapterId === chapterId)

      if (!content.classList.contains('collapsed')) {
        content.style.maxHeight = content.scrollHeight + 'px'
        if (chevron) chevron.style.transform = 'rotate(180deg)'
      } else {
        if (chevron) chevron.style.transform = 'rotate(0deg)'
      }
    })

    // Initialize profile section as collapsed
    if (this.hasProfileContentTarget) {
      this.profileContentTarget.style.maxHeight = '0'
      if (this.hasProfileChevronTarget) {
        this.profileChevronTarget.style.transform = 'rotate(0deg)'
      }
    }
  }

  toggleChapter(event) {
    const chapterId = event.currentTarget.dataset.chapterId
    const content = this.chapterContentTargets.find(el => el.dataset.chapterId === chapterId)
    const chevron = this.chapterChevronTargets.find(el => el.dataset.chapterId === chapterId)

    if (content.classList.contains('collapsed')) {
      // Expand
      content.classList.remove('collapsed')
      content.style.maxHeight = content.scrollHeight + 'px'
      chevron.style.transform = 'rotate(180deg)'
    } else {
      // Collapse
      content.classList.add('collapsed')
      content.style.maxHeight = '0'
      chevron.style.transform = 'rotate(0deg)'
    }
  }

  toggleProfile(event) {
    event.preventDefault()
    const content = this.profileContentTarget
    const chevron = this.profileChevronTarget
    const isCollapsed = content.style.maxHeight === '0px' || content.style.maxHeight === '0'

    if (isCollapsed) {
      // Expand
      content.style.maxHeight = content.scrollHeight + 'px'
      chevron.style.transform = 'rotate(180deg)'
    } else {
      // Collapse
      content.style.maxHeight = '0'
      chevron.style.transform = 'rotate(0deg)'
    }
  }
}
